import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Root = styled(Box)({
    '& .tableWapper': {
        width: '100%',
        height: '600px',
        overflowX: 'auto',
        '& .tableHead': {
            paddingLeft: '40px',
            height: '60px',
            color: '#9B9B9B',
            backgroundColor: '#FAFAFA',
            borderBottom: '1px solid #D8D8D8',
        },
        '& .iconExpand': {
            margin: '0 10px',
            transform: "rotate(0deg)",
            color: '#9B9B9B',
        },
        '& .iconClose': {
            margin: '0 10px',
            transform: "rotate(-90deg)",
            color: '#9B9B9B',
        },
        '& .extend': {
            backgroundColor: '#fff',
        },
        '& .expandBtn': {
            cursor: 'pointer',
            height: '60px',
            color: '#005F9B',
            fontWeight: 'bold',
            backgroundColor: '#fff',
            borderBottom: '1px solid #D8D8D8',
        },
        '& .closeBtn': {
            cursor: 'pointer',
            height: '60px',
            backgroundColor: '#fff',
            borderBottom: '1px solid #D8D8D8',
        },
        '& .table': {
            minWidth: '650px',
        },
        '& .w290': {
            width: '290px',
        },
        '& .noTeams': {
            height: '60px',
            color: '#9B9B9B',
            borderBottom: '1px solid #D8D8D8',
        },
    },
    '& .info': {
        backgroundColor: '#fff',
        padding: '24px',
        marginTop: '17px',
    },
    '& .textField': {
        width: '100%'
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#d8d8d8',
        margin: '20px 0',
    },
    '& .title2': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginBottom: '18px',
    },
    '& .members': {
        height: '265px',
        '& .member': {
            width: '48%',
            height: '100%',
            padding: '10px 20px',
            backgroundColor: '#F2F0F3',
        },
        '& .textField': {
            marginRight: '13px',
            backgroundColor: '#fff',
        },
    },
    '& .teamList': {
        height: '70%',
        overflow: 'auto',
        '& .item': {
            padding: '9px 0',
            borderBottom: '1px dashed #D8D8D8',
        },
        '& .delWapper': {
            cursor: 'pointer',
            '& .del': {
                color: '#9B9B9B',
            },
        },
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
});